import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DpsVcdModule } from '../../dataprotection/dataprotection-vcd/dataprotection-vcd.module';
import { ActivityLogModule } from '../../../components/activity-log/activity-log.module';
import { RouterModule } from '@angular/router';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';

import ComputeVCD from './compute-vcd.component';

import Organization from './organization/organization.component';
import EditOrganization from './organization/edit/organization-edit.component';
import DeleteOrganization from './organization/delete/organization-delete.component';

import Vdc from './vdc/vdc.component';
import { DeleteVdc } from './vdc/delete/vdc-delete.component';

import { OrgVdcWizardModule } from './org-vdc-wizard/org-vdc.wizard.module';
import { ComputeDashboard } from './dashboard/compute-dashboard.component';
/*import { ComputeDashboardVc } from './dashboard-vc/compute-dashboard-vc.component';
import { ComputeServiceVc } from "./dashboard-vc/compute-vc.service";*/
import { SharedService } from './org-vdc-wizard/shared-service';
import { RefreshSharedService } from '../../../refresh-shared-service';

import Vm from './vm/vm.component';
import Vapp from './vapp/vapp.component';
import VAppGrid from './vapp-grid/vapp-grid.component';


@NgModule({
    declarations: [
        ComputeVCD,
        Organization,
        EditOrganization,
        DeleteOrganization,
        Vdc,
        DeleteVdc,
        ComputeDashboard,
        Vm,
        Vapp,
        VAppGrid/*,
        ComputeDashboardVc*/
    ],
    imports: [
        VcaCommonModule,
        BrowserModule,
        FormsModule,
        TranslateModule,
        ClarityModule.forRoot(),
        OrgVdcWizardModule,
        DpsVcdModule,
        ActivityLogModule,
        RouterModule
    ],
    providers: [
        /*ComputeServiceVc,*/
        SharedService,
        RefreshSharedService
    ],
    exports: [
        ComputeVCD,
        Organization,
        EditOrganization,
        DeleteOrganization,
        Vdc,
        DeleteVdc,
        ComputeDashboard,
        Vm,
        Vapp,
        VAppGrid/*,
        ComputeDashboardVc*/
    ]

})
export class ComputeVCDModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/compute-vcd.module.ts